/**
 * Created by guntherclaes on 03/03/2017.
 */
module.exports = exports = ['$httpProvider', 'cfpLoadingBarProvider', function ($httpProvider, cfpLoadingBarProvider) {
  $httpProvider.interceptors.push('httpInterceptorLoadingBar');
  cfpLoadingBarProvider.includeBar = false;
  cfpLoadingBarProvider.includeSpinner = false;
}];
